import Backbone   from "backbone";
import {defaults} from "../../commun/backbone/decorators";

@defaults({
                language_is_visible: false,
                languages : [],
                base_image_url: '',
                default_language: '',
                request_locale: '',
          })
class LoginBaseModel extends Backbone.Model
{
    findLanguage(codeOrLocale)
    {
        const languages = this.get('languages');
        if (parseInt(codeOrLocale)){
            return languages.find(function(language){ return language.code === codeOrLocale;});
        }

        //c'est pas un code mais une locale
        codeOrLocale = codeOrLocale.replace('-', '_');
        return languages.find(function(language){ return language.short === codeOrLocale;});
    }


    loadLanguage(code) {
        const languages = this.get('languages');
        if (languages.length === 0){
            return ;
        }
        if (!code){
            code = this.get('request_locale');
        }

        let language = this.findLanguage(code);
        if(!language)
        {
            //on cherche avec le language du navigateur pour voir si on trouve
            language = this.findLanguage(navigator.language);
            if(!language){
                language = this.findLanguage(this.get('default_language'));
                if(!language){
                    language = languages[0];
                }
            }
        }

        this.trigger('load-language', language);
    };
}
export default LoginBaseModel;